import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };

      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "GenericMorph": [
      "Bid",
      "Category",
      "Contact",
      "Exhibit",
      "Exhibition",
      "Gtc",
      "I18NLocale",
      "Impressum",
      "Laudatio",
      "Policy",
      "Regulation",
      "ReviewWorkflowsWorkflow",
      "ReviewWorkflowsWorkflowStage",
      "UploadFile",
      "User",
      "UsersPermissionsPermission",
      "UsersPermissionsRole",
      "VirtualTour"
    ]
  }
};
      export default result;
    
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: { input: any; output: any; }
};

export type Bid = {
  __typename?: 'Bid';
  amount: Scalars['Int']['output'];
  /** @deprecated Use root level fields instead */
  attributes: Bid;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Bid;
  documentId: Scalars['ID']['output'];
  exhibit?: Maybe<Exhibit>;
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users_permissions_user?: Maybe<User>;
};

export type BidEntityResponse = {
  __typename?: 'BidEntityResponse';
  data?: Maybe<Bid>;
};

export type BidEntityResponseCollection = {
  __typename?: 'BidEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<Bid>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Bid>;
  pageInfo: Pagination;
};

export type BidFiltersInput = {
  amount?: InputMaybe<IntFilterInput>;
  and?: InputMaybe<Array<InputMaybe<BidFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  exhibit?: InputMaybe<ExhibitFiltersInput>;
  not?: InputMaybe<BidFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<BidFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users_permissions_user?: InputMaybe<UserFiltersInput>;
};

export type BidInput = {
  amount?: InputMaybe<Scalars['Int']['input']>;
  exhibit?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  otp?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  users_permissions_user?: InputMaybe<Scalars['ID']['input']>;
};

export type BidRelationResponseCollection = {
  __typename?: 'BidRelationResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<Bid>;
  nodes: Array<Bid>;
};

export type BooleanFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  contains?: InputMaybe<Scalars['Boolean']['input']>;
  containsi?: InputMaybe<Scalars['Boolean']['input']>;
  endsWith?: InputMaybe<Scalars['Boolean']['input']>;
  eq?: InputMaybe<Scalars['Boolean']['input']>;
  eqi?: InputMaybe<Scalars['Boolean']['input']>;
  gt?: InputMaybe<Scalars['Boolean']['input']>;
  gte?: InputMaybe<Scalars['Boolean']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  lt?: InputMaybe<Scalars['Boolean']['input']>;
  lte?: InputMaybe<Scalars['Boolean']['input']>;
  ne?: InputMaybe<Scalars['Boolean']['input']>;
  nei?: InputMaybe<Scalars['Boolean']['input']>;
  not?: InputMaybe<BooleanFilterInput>;
  notContains?: InputMaybe<Scalars['Boolean']['input']>;
  notContainsi?: InputMaybe<Scalars['Boolean']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  startsWith?: InputMaybe<Scalars['Boolean']['input']>;
};

export type Category = {
  __typename?: 'Category';
  /** @deprecated Use root level fields instead */
  attributes: Category;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Category;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  order: Scalars['Int']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CategoryEntityResponseCollection = {
  __typename?: 'CategoryEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<Category>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Category>;
  pageInfo: Pagination;
};

export type CategoryFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<CategoryFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<CategoryFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type CategoryInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
};

export type Contact = {
  __typename?: 'Contact';
  /** @deprecated Use root level fields instead */
  attributes: Contact;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Contact;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ContactInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export type CreateTwilioVerifyVerificationResponse = {
  __typename?: 'CreateTwilioVerifyVerificationResponse';
  status: Scalars['String']['output'];
};

export type DateTimeFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  contains?: InputMaybe<Scalars['DateTime']['input']>;
  containsi?: InputMaybe<Scalars['DateTime']['input']>;
  endsWith?: InputMaybe<Scalars['DateTime']['input']>;
  eq?: InputMaybe<Scalars['DateTime']['input']>;
  eqi?: InputMaybe<Scalars['DateTime']['input']>;
  gt?: InputMaybe<Scalars['DateTime']['input']>;
  gte?: InputMaybe<Scalars['DateTime']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  lt?: InputMaybe<Scalars['DateTime']['input']>;
  lte?: InputMaybe<Scalars['DateTime']['input']>;
  ne?: InputMaybe<Scalars['DateTime']['input']>;
  nei?: InputMaybe<Scalars['DateTime']['input']>;
  not?: InputMaybe<DateTimeFilterInput>;
  notContains?: InputMaybe<Scalars['DateTime']['input']>;
  notContainsi?: InputMaybe<Scalars['DateTime']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['DateTime']['input']>>>;
  startsWith?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DeleteMutationResponse = {
  __typename?: 'DeleteMutationResponse';
  documentId: Scalars['ID']['output'];
};

export type Exhibit = {
  __typename?: 'Exhibit';
  /** @deprecated Use root level fields instead */
  attributes: Exhibit;
  auctionEnabled: Scalars['Boolean']['output'];
  bidding_step: Scalars['Int']['output'];
  bids: Array<Maybe<Bid>>;
  bids_connection?: Maybe<BidRelationResponseCollection>;
  category?: Maybe<Category>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Exhibit;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  image: UploadFile;
  minimum_amount?: Maybe<Scalars['Int']['output']>;
  moretext?: Maybe<Scalars['String']['output']>;
  order?: Maybe<Scalars['Int']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  slug: Scalars['String']['output'];
  sold: Scalars['Boolean']['output'];
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ExhibitBidsArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ExhibitBids_ConnectionArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ExhibitEntityResponse = {
  __typename?: 'ExhibitEntityResponse';
  data?: Maybe<Exhibit>;
};

export type ExhibitEntityResponseCollection = {
  __typename?: 'ExhibitEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<Exhibit>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<Exhibit>;
  pageInfo: Pagination;
};

export type ExhibitFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ExhibitFiltersInput>>>;
  auctionEnabled?: InputMaybe<BooleanFilterInput>;
  bidding_step?: InputMaybe<IntFilterInput>;
  bids?: InputMaybe<BidFiltersInput>;
  category?: InputMaybe<CategoryFiltersInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  minimum_amount?: InputMaybe<IntFilterInput>;
  moretext?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ExhibitFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ExhibitFiltersInput>>>;
  order?: InputMaybe<IntFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  slug?: InputMaybe<StringFilterInput>;
  sold?: InputMaybe<BooleanFilterInput>;
  text?: InputMaybe<StringFilterInput>;
  title?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ExhibitInput = {
  auctionEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  biddingLocked?: InputMaybe<Scalars['Boolean']['input']>;
  bidding_step?: InputMaybe<Scalars['Int']['input']>;
  bids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  category?: InputMaybe<Scalars['ID']['input']>;
  image?: InputMaybe<Scalars['ID']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  minimum_amount?: InputMaybe<Scalars['Int']['input']>;
  moretext?: InputMaybe<Scalars['String']['input']>;
  order?: InputMaybe<Scalars['Int']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  slug?: InputMaybe<Scalars['String']['input']>;
  sold?: InputMaybe<Scalars['Boolean']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Exhibition = {
  __typename?: 'Exhibition';
  /** @deprecated Use root level fields instead */
  attributes: Exhibition;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Exhibition;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ExhibitionInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export type FileInfoInput = {
  alternativeText?: InputMaybe<Scalars['String']['input']>;
  caption?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
};

export type FloatFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  contains?: InputMaybe<Scalars['Float']['input']>;
  containsi?: InputMaybe<Scalars['Float']['input']>;
  endsWith?: InputMaybe<Scalars['Float']['input']>;
  eq?: InputMaybe<Scalars['Float']['input']>;
  eqi?: InputMaybe<Scalars['Float']['input']>;
  gt?: InputMaybe<Scalars['Float']['input']>;
  gte?: InputMaybe<Scalars['Float']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  lt?: InputMaybe<Scalars['Float']['input']>;
  lte?: InputMaybe<Scalars['Float']['input']>;
  ne?: InputMaybe<Scalars['Float']['input']>;
  nei?: InputMaybe<Scalars['Float']['input']>;
  not?: InputMaybe<FloatFilterInput>;
  notContains?: InputMaybe<Scalars['Float']['input']>;
  notContainsi?: InputMaybe<Scalars['Float']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  startsWith?: InputMaybe<Scalars['Float']['input']>;
};

export type GenericMorph = Bid | Category | Contact | Exhibit | Exhibition | Gtc | I18NLocale | Impressum | Laudatio | Policy | Regulation | ReviewWorkflowsWorkflow | ReviewWorkflowsWorkflowStage | UploadFile | User | UsersPermissionsPermission | UsersPermissionsRole | VirtualTour;

export type Gtc = {
  __typename?: 'Gtc';
  /** @deprecated Use root level fields instead */
  attributes: Gtc;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Gtc;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GtcInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export type I18NLocale = {
  __typename?: 'I18NLocale';
  /** @deprecated Use root level fields instead */
  attributes: I18NLocale;
  code?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: I18NLocale;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type I18NLocaleEntityResponseCollection = {
  __typename?: 'I18NLocaleEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<I18NLocale>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<I18NLocale>;
  pageInfo: Pagination;
};

export type I18NLocaleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  code?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<I18NLocaleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<I18NLocaleFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type IdFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  contains?: InputMaybe<Scalars['ID']['input']>;
  containsi?: InputMaybe<Scalars['ID']['input']>;
  endsWith?: InputMaybe<Scalars['ID']['input']>;
  eq?: InputMaybe<Scalars['ID']['input']>;
  eqi?: InputMaybe<Scalars['ID']['input']>;
  gt?: InputMaybe<Scalars['ID']['input']>;
  gte?: InputMaybe<Scalars['ID']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  lt?: InputMaybe<Scalars['ID']['input']>;
  lte?: InputMaybe<Scalars['ID']['input']>;
  ne?: InputMaybe<Scalars['ID']['input']>;
  nei?: InputMaybe<Scalars['ID']['input']>;
  not?: InputMaybe<IdFilterInput>;
  notContains?: InputMaybe<Scalars['ID']['input']>;
  notContainsi?: InputMaybe<Scalars['ID']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  startsWith?: InputMaybe<Scalars['ID']['input']>;
};

export type Impressum = {
  __typename?: 'Impressum';
  /** @deprecated Use root level fields instead */
  attributes: Impressum;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Impressum;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type ImpressumInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export type IntFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  contains?: InputMaybe<Scalars['Int']['input']>;
  containsi?: InputMaybe<Scalars['Int']['input']>;
  endsWith?: InputMaybe<Scalars['Int']['input']>;
  eq?: InputMaybe<Scalars['Int']['input']>;
  eqi?: InputMaybe<Scalars['Int']['input']>;
  gt?: InputMaybe<Scalars['Int']['input']>;
  gte?: InputMaybe<Scalars['Int']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  lt?: InputMaybe<Scalars['Int']['input']>;
  lte?: InputMaybe<Scalars['Int']['input']>;
  ne?: InputMaybe<Scalars['Int']['input']>;
  nei?: InputMaybe<Scalars['Int']['input']>;
  not?: InputMaybe<IntFilterInput>;
  notContains?: InputMaybe<Scalars['Int']['input']>;
  notContainsi?: InputMaybe<Scalars['Int']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['Int']['input']>>>;
  startsWith?: InputMaybe<Scalars['Int']['input']>;
};

export type JsonFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  contains?: InputMaybe<Scalars['JSON']['input']>;
  containsi?: InputMaybe<Scalars['JSON']['input']>;
  endsWith?: InputMaybe<Scalars['JSON']['input']>;
  eq?: InputMaybe<Scalars['JSON']['input']>;
  eqi?: InputMaybe<Scalars['JSON']['input']>;
  gt?: InputMaybe<Scalars['JSON']['input']>;
  gte?: InputMaybe<Scalars['JSON']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  lt?: InputMaybe<Scalars['JSON']['input']>;
  lte?: InputMaybe<Scalars['JSON']['input']>;
  ne?: InputMaybe<Scalars['JSON']['input']>;
  nei?: InputMaybe<Scalars['JSON']['input']>;
  not?: InputMaybe<JsonFilterInput>;
  notContains?: InputMaybe<Scalars['JSON']['input']>;
  notContainsi?: InputMaybe<Scalars['JSON']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['JSON']['input']>>>;
  startsWith?: InputMaybe<Scalars['JSON']['input']>;
};

export type Laudatio = {
  __typename?: 'Laudatio';
  /** @deprecated Use root level fields instead */
  attributes: Laudatio;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Laudatio;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type LaudatioInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  /** Change user password. Confirm with the current password. */
  changePassword?: Maybe<UsersPermissionsLoginPayload>;
  createBid?: Maybe<Bid>;
  createBidTransactional?: Maybe<BidEntityResponse>;
  createCategory?: Maybe<Category>;
  createExhibit?: Maybe<Exhibit>;
  createReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  createReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  createTwilioVerifyVerification?: Maybe<CreateTwilioVerifyVerificationResponse>;
  /** Create a new user */
  createUser: UserEntityResponse;
  /** Create a new role */
  createUsersPermissionsRole?: Maybe<UsersPermissionsCreateRolePayload>;
  deleteBid?: Maybe<DeleteMutationResponse>;
  deleteCategory?: Maybe<DeleteMutationResponse>;
  deleteContact?: Maybe<DeleteMutationResponse>;
  deleteExhibit?: Maybe<DeleteMutationResponse>;
  deleteExhibition?: Maybe<DeleteMutationResponse>;
  deleteGtc?: Maybe<DeleteMutationResponse>;
  deleteImpressum?: Maybe<DeleteMutationResponse>;
  deleteLaudatio?: Maybe<DeleteMutationResponse>;
  deletePolicy?: Maybe<DeleteMutationResponse>;
  deleteRegulation?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflow?: Maybe<DeleteMutationResponse>;
  deleteReviewWorkflowsWorkflowStage?: Maybe<DeleteMutationResponse>;
  deleteUploadFile?: Maybe<UploadFile>;
  /** Delete an existing user */
  deleteUser: UserEntityResponse;
  /** Delete an existing role */
  deleteUsersPermissionsRole?: Maybe<UsersPermissionsDeleteRolePayload>;
  deleteVirtualTour?: Maybe<DeleteMutationResponse>;
  /** Confirm an email users email address */
  emailConfirmation?: Maybe<UsersPermissionsLoginPayload>;
  /** Request a reset password token */
  forgotPassword?: Maybe<UsersPermissionsPasswordPayload>;
  login: UsersPermissionsLoginPayload;
  /** Register a user */
  register: UsersPermissionsLoginPayload;
  /** Reset user password. Confirm with a code (resetToken from forgotPassword) */
  resetPassword?: Maybe<UsersPermissionsLoginPayload>;
  updateBid?: Maybe<Bid>;
  updateCategory?: Maybe<Category>;
  updateContact?: Maybe<Contact>;
  updateExhibit?: Maybe<Exhibit>;
  updateExhibition?: Maybe<Exhibition>;
  updateGtc?: Maybe<Gtc>;
  updateImpressum?: Maybe<Impressum>;
  updateLaudatio?: Maybe<Laudatio>;
  updateMe?: Maybe<UsersPermissionsMe>;
  updatePolicy?: Maybe<Policy>;
  updateRegulation?: Maybe<Regulation>;
  updateReviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  updateReviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  updateUploadFile: UploadFile;
  /** Update an existing user */
  updateUser: UserEntityResponse;
  /** Update an existing role */
  updateUsersPermissionsRole?: Maybe<UsersPermissionsUpdateRolePayload>;
  updateVirtualTour?: Maybe<VirtualTour>;
};


export type MutationChangePasswordArgs = {
  currentPassword: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationCreateBidArgs = {
  data: BidInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateBidTransactionalArgs = {
  data: BidInput;
};


export type MutationCreateCategoryArgs = {
  data: CategoryInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateExhibitArgs = {
  data: ExhibitInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationCreateUserArgs = {
  data: UserInput;
};


export type MutationCreateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
};


export type MutationDeleteBidArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteCategoryArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteExhibitArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
};


export type MutationDeleteUploadFileArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUserArgs = {
  id: Scalars['ID']['input'];
};


export type MutationDeleteUsersPermissionsRoleArgs = {
  id: Scalars['ID']['input'];
};


export type MutationEmailConfirmationArgs = {
  confirmation: Scalars['String']['input'];
};


export type MutationForgotPasswordArgs = {
  email: Scalars['String']['input'];
};


export type MutationLoginArgs = {
  input: UsersPermissionsLoginInput;
};


export type MutationRegisterArgs = {
  input: UsersPermissionsRegisterInput;
};


export type MutationResetPasswordArgs = {
  code: Scalars['String']['input'];
  password: Scalars['String']['input'];
  passwordConfirmation: Scalars['String']['input'];
};


export type MutationUpdateBidArgs = {
  data: BidInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateCategoryArgs = {
  data: CategoryInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateContactArgs = {
  data: ContactInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateExhibitArgs = {
  data: ExhibitInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateExhibitionArgs = {
  data: ExhibitionInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateGtcArgs = {
  data: GtcInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateImpressumArgs = {
  data: ImpressumInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateLaudatioArgs = {
  data: LaudatioInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateMeArgs = {
  data: UpdateMeInput;
};


export type MutationUpdatePolicyArgs = {
  data: PolicyInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateRegulationArgs = {
  data: RegulationInput;
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowArgs = {
  data: ReviewWorkflowsWorkflowInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateReviewWorkflowsWorkflowStageArgs = {
  data: ReviewWorkflowsWorkflowStageInput;
  documentId: Scalars['ID']['input'];
  status?: InputMaybe<PublicationStatus>;
};


export type MutationUpdateUploadFileArgs = {
  id: Scalars['ID']['input'];
  info?: InputMaybe<FileInfoInput>;
};


export type MutationUpdateUserArgs = {
  data: UserInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateUsersPermissionsRoleArgs = {
  data: UsersPermissionsRoleInput;
  id: Scalars['ID']['input'];
};


export type MutationUpdateVirtualTourArgs = {
  data: VirtualTourInput;
  status?: InputMaybe<PublicationStatus>;
};

export type Pagination = {
  __typename?: 'Pagination';
  page: Scalars['Int']['output'];
  pageCount: Scalars['Int']['output'];
  pageSize: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PaginationArg = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  pageSize?: InputMaybe<Scalars['Int']['input']>;
  start?: InputMaybe<Scalars['Int']['input']>;
};

export type Policy = {
  __typename?: 'Policy';
  /** @deprecated Use root level fields instead */
  attributes: Policy;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Policy;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type PolicyInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export enum PublicationFilter {
  HasPublishedVersion = 'HAS_PUBLISHED_VERSION',
  HasPublishedVersionDocument = 'HAS_PUBLISHED_VERSION_DOCUMENT',
  Modified = 'MODIFIED',
  NeverPublished = 'NEVER_PUBLISHED',
  NeverPublishedDocument = 'NEVER_PUBLISHED_DOCUMENT',
  PublishedWithoutDraft = 'PUBLISHED_WITHOUT_DRAFT',
  PublishedWithDraft = 'PUBLISHED_WITH_DRAFT',
  Unmodified = 'UNMODIFIED'
}

export enum PublicationStatus {
  Draft = 'DRAFT',
  Published = 'PUBLISHED'
}

export type Query = {
  __typename?: 'Query';
  bid?: Maybe<Bid>;
  bids: Array<Maybe<Bid>>;
  bids_connection?: Maybe<BidEntityResponseCollection>;
  categories: Array<Maybe<Category>>;
  categories_connection?: Maybe<CategoryEntityResponseCollection>;
  category?: Maybe<Category>;
  contact?: Maybe<Contact>;
  exhibit?: Maybe<ExhibitEntityResponse>;
  exhibition?: Maybe<Exhibition>;
  exhibits: Array<Maybe<Exhibit>>;
  exhibits_connection?: Maybe<ExhibitEntityResponseCollection>;
  gtc?: Maybe<Gtc>;
  i18NLocale?: Maybe<I18NLocale>;
  i18NLocales: Array<Maybe<I18NLocale>>;
  i18NLocales_connection?: Maybe<I18NLocaleEntityResponseCollection>;
  impressum?: Maybe<Impressum>;
  laudatio?: Maybe<Laudatio>;
  me?: Maybe<UsersPermissionsMe>;
  policy?: Maybe<Policy>;
  regulation?: Maybe<Regulation>;
  reviewWorkflowsWorkflow?: Maybe<ReviewWorkflowsWorkflow>;
  reviewWorkflowsWorkflowStage?: Maybe<ReviewWorkflowsWorkflowStage>;
  reviewWorkflowsWorkflowStages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  reviewWorkflowsWorkflowStages_connection?: Maybe<ReviewWorkflowsWorkflowStageEntityResponseCollection>;
  reviewWorkflowsWorkflows: Array<Maybe<ReviewWorkflowsWorkflow>>;
  reviewWorkflowsWorkflows_connection?: Maybe<ReviewWorkflowsWorkflowEntityResponseCollection>;
  twilioVerifySettings?: Maybe<TwilioVerifySettingsResponse>;
  uploadFile?: Maybe<UploadFile>;
  uploadFiles: Array<Maybe<UploadFile>>;
  uploadFiles_connection?: Maybe<UploadFileEntityResponseCollection>;
  user?: Maybe<User>;
  userExhibits?: Maybe<ExhibitEntityResponseCollection>;
  users: Array<Maybe<User>>;
  usersPermissionsRole?: Maybe<UsersPermissionsRole>;
  usersPermissionsRoles: Array<Maybe<UsersPermissionsRole>>;
  usersPermissionsRoles_connection?: Maybe<UsersPermissionsRoleEntityResponseCollection>;
  users_connection?: Maybe<UserEntityResponseCollection>;
  virtualTour?: Maybe<VirtualTour>;
};


export type QueryBidArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBidsArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryBids_ConnectionArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategoriesArgs = {
  filters?: InputMaybe<CategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategories_ConnectionArgs = {
  filters?: InputMaybe<CategoryFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryCategoryArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryContactArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibitArgs = {
  slug: Scalars['String']['input'];
};


export type QueryExhibitionArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibitsArgs = {
  filters?: InputMaybe<ExhibitFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryExhibits_ConnectionArgs = {
  filters?: InputMaybe<ExhibitFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryGtcArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocaleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocalesArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryI18NLocales_ConnectionArgs = {
  filters?: InputMaybe<I18NLocaleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryImpressumArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryLaudatioArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryPolicyArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryRegulationArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStageArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflowsArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryReviewWorkflowsWorkflows_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFileArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFilesArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUploadFiles_ConnectionArgs = {
  filters?: InputMaybe<UploadFileFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUserArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoleArgs = {
  documentId: Scalars['ID']['input'];
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRolesArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsersPermissionsRoles_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryUsers_ConnectionArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  pagination?: InputMaybe<PaginationArg>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<PublicationStatus>;
};


export type QueryVirtualTourArgs = {
  hasPublishedVersion?: InputMaybe<Scalars['Boolean']['input']>;
  publicationFilter?: InputMaybe<PublicationFilter>;
  status?: InputMaybe<PublicationStatus>;
};

export type Regulation = {
  __typename?: 'Regulation';
  /** @deprecated Use root level fields instead */
  attributes: Regulation;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: Regulation;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  titel?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type RegulationInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  text?: InputMaybe<Scalars['String']['input']>;
  titel?: InputMaybe<Scalars['String']['input']>;
};

export type ResponseCollectionMeta = {
  __typename?: 'ResponseCollectionMeta';
  pagination: Pagination;
};

export type ReviewWorkflowsWorkflow = {
  __typename?: 'ReviewWorkflowsWorkflow';
  /** @deprecated Use root level fields instead */
  attributes: ReviewWorkflowsWorkflow;
  contentTypes: Scalars['JSON']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: ReviewWorkflowsWorkflow;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  stageRequiredToPublish?: Maybe<ReviewWorkflowsWorkflowStage>;
  stages: Array<Maybe<ReviewWorkflowsWorkflowStage>>;
  stages_connection?: Maybe<ReviewWorkflowsWorkflowStageRelationResponseCollection>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};


export type ReviewWorkflowsWorkflowStagesArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type ReviewWorkflowsWorkflowStages_ConnectionArgs = {
  filters?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ReviewWorkflowsWorkflowEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflow>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ReviewWorkflowsWorkflow>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  contentTypes?: InputMaybe<JsonFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  stageRequiredToPublish?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  stages?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type ReviewWorkflowsWorkflowInput = {
  contentTypes?: InputMaybe<Scalars['JSON']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  stageRequiredToPublish?: InputMaybe<Scalars['ID']['input']>;
  stages?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type ReviewWorkflowsWorkflowStage = {
  __typename?: 'ReviewWorkflowsWorkflowStage';
  /** @deprecated Use root level fields instead */
  attributes: ReviewWorkflowsWorkflowStage;
  color?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: ReviewWorkflowsWorkflowStage;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  workflow?: Maybe<ReviewWorkflowsWorkflow>;
};

export type ReviewWorkflowsWorkflowStageEntityResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflowStage>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<ReviewWorkflowsWorkflowStage>;
  pageInfo: Pagination;
};

export type ReviewWorkflowsWorkflowStageFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  color?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<ReviewWorkflowsWorkflowStageFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  workflow?: InputMaybe<ReviewWorkflowsWorkflowFiltersInput>;
};

export type ReviewWorkflowsWorkflowStageInput = {
  color?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  workflow?: InputMaybe<Scalars['ID']['input']>;
};

export type ReviewWorkflowsWorkflowStageRelationResponseCollection = {
  __typename?: 'ReviewWorkflowsWorkflowStageRelationResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<ReviewWorkflowsWorkflowStage>;
  nodes: Array<ReviewWorkflowsWorkflowStage>;
};

export type StringFilterInput = {
  and?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  between?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  contains?: InputMaybe<Scalars['String']['input']>;
  containsi?: InputMaybe<Scalars['String']['input']>;
  endsWith?: InputMaybe<Scalars['String']['input']>;
  eq?: InputMaybe<Scalars['String']['input']>;
  eqi?: InputMaybe<Scalars['String']['input']>;
  gt?: InputMaybe<Scalars['String']['input']>;
  gte?: InputMaybe<Scalars['String']['input']>;
  in?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  lt?: InputMaybe<Scalars['String']['input']>;
  lte?: InputMaybe<Scalars['String']['input']>;
  ne?: InputMaybe<Scalars['String']['input']>;
  nei?: InputMaybe<Scalars['String']['input']>;
  not?: InputMaybe<StringFilterInput>;
  notContains?: InputMaybe<Scalars['String']['input']>;
  notContainsi?: InputMaybe<Scalars['String']['input']>;
  notIn?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  notNull?: InputMaybe<Scalars['Boolean']['input']>;
  null?: InputMaybe<Scalars['Boolean']['input']>;
  or?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  startsWith?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioVerifySettingsResponse = {
  __typename?: 'TwilioVerifySettingsResponse';
  enabled: Scalars['Boolean']['output'];
};

export type UpdateMeInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UploadFile = {
  __typename?: 'UploadFile';
  alternativeText?: Maybe<Scalars['String']['output']>;
  /** @deprecated Use root level fields instead */
  attributes: UploadFile;
  caption?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: UploadFile;
  documentId: Scalars['ID']['output'];
  ext?: Maybe<Scalars['String']['output']>;
  focalPoint?: Maybe<Scalars['JSON']['output']>;
  formats?: Maybe<Scalars['JSON']['output']>;
  hash: Scalars['String']['output'];
  height?: Maybe<Scalars['Int']['output']>;
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  previewUrl?: Maybe<Scalars['String']['output']>;
  provider: Scalars['String']['output'];
  provider_metadata?: Maybe<Scalars['JSON']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  related?: Maybe<Array<Maybe<GenericMorph>>>;
  size: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
  width?: Maybe<Scalars['Int']['output']>;
};

export type UploadFileEntityResponseCollection = {
  __typename?: 'UploadFileEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<UploadFile>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<UploadFile>;
  pageInfo: Pagination;
};

export type UploadFileFiltersInput = {
  alternativeText?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  caption?: InputMaybe<StringFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  ext?: InputMaybe<StringFilterInput>;
  focalPoint?: InputMaybe<JsonFilterInput>;
  formats?: InputMaybe<JsonFilterInput>;
  hash?: InputMaybe<StringFilterInput>;
  height?: InputMaybe<IntFilterInput>;
  mime?: InputMaybe<StringFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UploadFileFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UploadFileFiltersInput>>>;
  previewUrl?: InputMaybe<StringFilterInput>;
  provider?: InputMaybe<StringFilterInput>;
  provider_metadata?: InputMaybe<JsonFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  size?: InputMaybe<FloatFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  url?: InputMaybe<StringFilterInput>;
  width?: InputMaybe<IntFilterInput>;
};

export type User = {
  __typename?: 'User';
  address: Scalars['String']['output'];
  /** @deprecated Use root level fields instead */
  attributes: User;
  bids: Array<Maybe<Bid>>;
  bids_connection?: Maybe<BidRelationResponseCollection>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  city: Scalars['String']['output'];
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: User;
  documentId: Scalars['ID']['output'];
  email: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  gtcAccepted: Scalars['Boolean']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  lastName: Scalars['String']['output'];
  mobile: Scalars['String']['output'];
  provider?: Maybe<Scalars['String']['output']>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  username: Scalars['String']['output'];
  zip: Scalars['String']['output'];
};


export type UserBidsArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UserBids_ConnectionArgs = {
  filters?: InputMaybe<BidFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UserEntityResponse = {
  __typename?: 'UserEntityResponse';
  data?: Maybe<User>;
};

export type UserEntityResponseCollection = {
  __typename?: 'UserEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<User>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<User>;
  pageInfo: Pagination;
};

export type UserFiltersInput = {
  address?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UserFiltersInput>>>;
  bids?: InputMaybe<BidFiltersInput>;
  blocked?: InputMaybe<BooleanFilterInput>;
  city?: InputMaybe<StringFilterInput>;
  confirmed?: InputMaybe<BooleanFilterInput>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  email?: InputMaybe<StringFilterInput>;
  firstName?: InputMaybe<StringFilterInput>;
  gtcAccepted?: InputMaybe<BooleanFilterInput>;
  lastName?: InputMaybe<StringFilterInput>;
  mobile?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UserFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UserFiltersInput>>>;
  provider?: InputMaybe<StringFilterInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  username?: InputMaybe<StringFilterInput>;
  zip?: InputMaybe<StringFilterInput>;
};

export type UserInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  bids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  blocked?: InputMaybe<Scalars['Boolean']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  confirmationToken?: InputMaybe<Scalars['String']['input']>;
  confirmed?: InputMaybe<Scalars['Boolean']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  gtcAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  password?: InputMaybe<Scalars['String']['input']>;
  provider?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  resetPasswordToken?: InputMaybe<Scalars['String']['input']>;
  role?: InputMaybe<Scalars['ID']['input']>;
  username?: InputMaybe<Scalars['String']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UserRelationResponseCollection = {
  __typename?: 'UserRelationResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<User>;
  nodes: Array<User>;
};

export type UsersPermissionsCreateRolePayload = {
  __typename?: 'UsersPermissionsCreateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsDeleteRolePayload = {
  __typename?: 'UsersPermissionsDeleteRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsLoginInput = {
  identifier: Scalars['String']['input'];
  password: Scalars['String']['input'];
  provider?: Scalars['String']['input'];
};

export type UsersPermissionsLoginPayload = {
  __typename?: 'UsersPermissionsLoginPayload';
  jwt?: Maybe<Scalars['String']['output']>;
  user: UsersPermissionsMe;
};

export type UsersPermissionsMe = {
  __typename?: 'UsersPermissionsMe';
  address?: Maybe<Scalars['String']['output']>;
  blocked?: Maybe<Scalars['Boolean']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  confirmed?: Maybe<Scalars['Boolean']['output']>;
  documentId: Scalars['ID']['output'];
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gtcAccepted?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['ID']['output'];
  lastName?: Maybe<Scalars['String']['output']>;
  mobile?: Maybe<Scalars['String']['output']>;
  role?: Maybe<UsersPermissionsMeRole>;
  username: Scalars['String']['output'];
  zip?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsMeRole = {
  __typename?: 'UsersPermissionsMeRole';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type UsersPermissionsPasswordPayload = {
  __typename?: 'UsersPermissionsPasswordPayload';
  ok: Scalars['Boolean']['output'];
};

export type UsersPermissionsPermission = {
  __typename?: 'UsersPermissionsPermission';
  action: Scalars['String']['output'];
  /** @deprecated Use root level fields instead */
  attributes: UsersPermissionsPermission;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: UsersPermissionsPermission;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  role?: Maybe<UsersPermissionsRole>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type UsersPermissionsPermissionFiltersInput = {
  action?: InputMaybe<StringFilterInput>;
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  not?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsPermissionFiltersInput>>>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  role?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
};

export type UsersPermissionsPermissionRelationResponseCollection = {
  __typename?: 'UsersPermissionsPermissionRelationResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsPermission>;
  nodes: Array<UsersPermissionsPermission>;
};

export type UsersPermissionsRegisterInput = {
  address?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  email: Scalars['String']['input'];
  firstName?: InputMaybe<Scalars['String']['input']>;
  gtcAccepted?: InputMaybe<Scalars['Boolean']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  mobile?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
  username: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type UsersPermissionsRole = {
  __typename?: 'UsersPermissionsRole';
  /** @deprecated Use root level fields instead */
  attributes: UsersPermissionsRole;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: UsersPermissionsRole;
  description?: Maybe<Scalars['String']['output']>;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  permissions: Array<Maybe<UsersPermissionsPermission>>;
  permissions_connection?: Maybe<UsersPermissionsPermissionRelationResponseCollection>;
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  users: Array<Maybe<User>>;
  users_connection?: Maybe<UserRelationResponseCollection>;
};


export type UsersPermissionsRolePermissionsArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRolePermissions_ConnectionArgs = {
  filters?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsersArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


export type UsersPermissionsRoleUsers_ConnectionArgs = {
  filters?: InputMaybe<UserFiltersInput>;
  pagination?: InputMaybe<PaginationArg>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type UsersPermissionsRoleEntityResponseCollection = {
  __typename?: 'UsersPermissionsRoleEntityResponseCollection';
  /** @deprecated Use `nodes` field instead */
  data: Array<UsersPermissionsRole>;
  /** @deprecated Use the `pageInfo` field instead */
  meta: ResponseCollectionMeta;
  nodes: Array<UsersPermissionsRole>;
  pageInfo: Pagination;
};

export type UsersPermissionsRoleFiltersInput = {
  and?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  createdAt?: InputMaybe<DateTimeFilterInput>;
  description?: InputMaybe<StringFilterInput>;
  documentId?: InputMaybe<IdFilterInput>;
  name?: InputMaybe<StringFilterInput>;
  not?: InputMaybe<UsersPermissionsRoleFiltersInput>;
  or?: InputMaybe<Array<InputMaybe<UsersPermissionsRoleFiltersInput>>>;
  permissions?: InputMaybe<UsersPermissionsPermissionFiltersInput>;
  publishedAt?: InputMaybe<DateTimeFilterInput>;
  type?: InputMaybe<StringFilterInput>;
  updatedAt?: InputMaybe<DateTimeFilterInput>;
  users?: InputMaybe<UserFiltersInput>;
};

export type UsersPermissionsRoleInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  locale?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  permissions?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  users?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type UsersPermissionsUpdateRolePayload = {
  __typename?: 'UsersPermissionsUpdateRolePayload';
  ok: Scalars['Boolean']['output'];
};

export type VirtualTour = {
  __typename?: 'VirtualTour';
  /** @deprecated Use root level fields instead */
  attributes: VirtualTour;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  /** @deprecated Use root level fields instead */
  data: VirtualTour;
  documentId: Scalars['ID']['output'];
  /** @deprecated Use `documentId` instead */
  id: Scalars['ID']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  title: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  url: Scalars['String']['output'];
};

export type VirtualTourInput = {
  locale?: InputMaybe<Scalars['String']['input']>;
  publishedAt?: InputMaybe<Scalars['DateTime']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
};

export type TwilioVerifySettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type TwilioVerifySettingsQuery = { __typename?: 'Query', twilioVerifySettings?: { __typename?: 'TwilioVerifySettingsResponse', enabled: boolean } | null };

export type CreateBidTokenMutationVariables = Exact<{ [key: string]: never; }>;


export type CreateBidTokenMutation = { __typename?: 'Mutation', createTwilioVerifyVerification?: { __typename?: 'CreateTwilioVerifyVerificationResponse', status: string } | null };

export type BidAttributesFragment = { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null };

export type BidEntityAttributesFragment = { __typename?: 'Bid', id: string, attributes: { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null } };

export type ExhibitBidsQueryVariables = Exact<{
  filterInput: BidFiltersInput;
  pageSize: Scalars['Int']['input'];
}>;


export type ExhibitBidsQuery = { __typename?: 'Query', bids?: { __typename?: 'BidEntityResponseCollection', data: Array<{ __typename?: 'Bid', id: string, attributes: { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null } }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, total: number, pageSize: number, pageCount: number } } } | null };

export type CreateBidTransactionalMutationVariables = Exact<{
  input: BidInput;
}>;


export type CreateBidTransactionalMutation = { __typename?: 'Mutation', createBidTransactional?: { __typename?: 'BidEntityResponse', data?: { __typename?: 'Bid', id: string, attributes: { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null } } | null } | null };

export type CategoryAttributesFragment = { __typename?: 'Category', name: string, slug: string };

export type CategoryEntityAttributesFragment = { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } };

export type CategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CategoriesQuery = { __typename?: 'Query', categories?: { __typename?: 'CategoryEntityResponseCollection', data: Array<{ __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } }> } | null };

export type ContactQueryVariables = Exact<{ [key: string]: never; }>;


export type ContactQuery = { __typename?: 'Query', contact?: { __typename?: 'Contact', data: { __typename?: 'Contact', attributes: { __typename?: 'Contact', text?: string | null, titel?: string | null } } } | null };

export type ExhibitionQueryVariables = Exact<{ [key: string]: never; }>;


export type ExhibitionQuery = { __typename?: 'Query', exhibition?: { __typename?: 'Exhibition', data: { __typename?: 'Exhibition', attributes: { __typename?: 'Exhibition', text?: string | null, titel?: string | null } } } | null };

export type ImageAttributesFragment = { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string };

export type ImageEntityAttributesFragment = { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } };

export type ExhibitAttributesFragment = { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } };

export type ExhibitEntityAttributesFragment = { __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } };

export type UserExhibitEntityAttributesFragment = { __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, bids?: { __typename?: 'BidRelationResponseCollection', data: Array<{ __typename?: 'Bid', id: string, attributes: { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null } }> } | null, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } };

export type ExhibitsQueryVariables = Exact<{ [key: string]: never; }>;


export type ExhibitsQuery = { __typename?: 'Query', exhibits?: { __typename?: 'ExhibitEntityResponseCollection', data: Array<{ __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, total: number, pageSize: number, pageCount: number } } } | null };

export type CategoryExhibitsQueryVariables = Exact<{
  categorySlug: Scalars['String']['input'];
  pagination?: InputMaybe<PaginationArg>;
}>;


export type CategoryExhibitsQuery = { __typename?: 'Query', exhibits?: { __typename?: 'ExhibitEntityResponseCollection', data: Array<{ __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } }>, meta: { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, total: number, pageSize: number, pageCount: number } } } | null };

export type UserExhibitsQueryVariables = Exact<{ [key: string]: never; }>;


export type UserExhibitsQuery = { __typename?: 'Query', userExhibits?: { __typename?: 'ExhibitEntityResponseCollection', data: Array<{ __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, bids?: { __typename?: 'BidRelationResponseCollection', data: Array<{ __typename?: 'Bid', id: string, attributes: { __typename?: 'Bid', amount: number, createdAt?: any | null, updatedAt?: any | null, users_permissions_user?: { __typename?: 'User', data: { __typename?: 'User', id: string, attributes: { __typename?: 'User', username: string } } } | null } }> } | null, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } }> } | null };

export type ExhibitQueryVariables = Exact<{
  slug: Scalars['String']['input'];
}>;


export type ExhibitQuery = { __typename?: 'Query', exhibit?: { __typename?: 'ExhibitEntityResponse', data?: { __typename?: 'Exhibit', id: string, attributes: { __typename?: 'Exhibit', slug: string, title: string, text?: string | null, moretext?: string | null, minimum_amount?: number | null, bidding_step: number, createdAt?: any | null, updatedAt?: any | null, auctionEnabled: boolean, sold: boolean, category?: { __typename?: 'Category', data: { __typename?: 'Category', id: string, attributes: { __typename?: 'Category', name: string, slug: string } } } | null, image: { __typename?: 'UploadFile', data: { __typename?: 'UploadFile', id: string, attributes: { __typename?: 'UploadFile', name: string, caption?: string | null, formats?: any | null, createdAt?: any | null, updatedAt?: any | null, url: string } } } } } | null } | null };

export type GtcQueryVariables = Exact<{ [key: string]: never; }>;


export type GtcQuery = { __typename?: 'Query', gtc?: { __typename?: 'Gtc', data: { __typename?: 'Gtc', attributes: { __typename?: 'Gtc', text?: string | null, titel?: string | null } } } | null };

export type ImpressumQueryVariables = Exact<{ [key: string]: never; }>;


export type ImpressumQuery = { __typename?: 'Query', impressum?: { __typename?: 'Impressum', data: { __typename?: 'Impressum', attributes: { __typename?: 'Impressum', text?: string | null, titel?: string | null } } } | null };

export type LaudatioQueryVariables = Exact<{ [key: string]: never; }>;


export type LaudatioQuery = { __typename?: 'Query', laudatio?: { __typename?: 'Laudatio', data: { __typename?: 'Laudatio', attributes: { __typename?: 'Laudatio', text?: string | null, title: string } } } | null };

export type PolicyQueryVariables = Exact<{ [key: string]: never; }>;


export type PolicyQuery = { __typename?: 'Query', policy?: { __typename?: 'Policy', data: { __typename?: 'Policy', attributes: { __typename?: 'Policy', text?: string | null, titel?: string | null } } } | null };

export type RegulationQueryVariables = Exact<{ [key: string]: never; }>;


export type RegulationQuery = { __typename?: 'Query', regulation?: { __typename?: 'Regulation', data: { __typename?: 'Regulation', attributes: { __typename?: 'Regulation', text?: string | null, titel?: string | null } } } | null };

export type PaginationDetailsFragment = { __typename?: 'ResponseCollectionMeta', pagination: { __typename?: 'Pagination', page: number, total: number, pageSize: number, pageCount: number } };

export type UserAttributesFragment = { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null } | null };

export type UpdateMeMutationVariables = Exact<{
  data: UpdateMeInput;
}>;


export type UpdateMeMutation = { __typename?: 'Mutation', updateMe?: { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null } | null };

export type LoginMutationVariables = Exact<{
  input: UsersPermissionsLoginInput;
}>;


export type LoginMutation = { __typename?: 'Mutation', login: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null } } };

export type RegisterMutationVariables = Exact<{
  input: UsersPermissionsRegisterInput;
}>;


export type RegisterMutation = { __typename?: 'Mutation', register: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null } } };

export type ForgotPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ForgotPasswordMutation = { __typename?: 'Mutation', forgotPassword?: { __typename?: 'UsersPermissionsPasswordPayload', ok: boolean } | null };

export type ResetPasswordMutationVariables = Exact<{
  password: Scalars['String']['input'];
  code: Scalars['String']['input'];
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: { __typename?: 'UsersPermissionsLoginPayload', jwt?: string | null, user: { __typename?: 'UsersPermissionsMe', id: string, lastName?: string | null, firstName?: string | null, username: string, email?: string | null, mobile?: string | null, address?: string | null, zip?: string | null, city?: string | null } } | null };

export type VirtualTourQueryVariables = Exact<{ [key: string]: never; }>;


export type VirtualTourQuery = { __typename?: 'Query', virtualTour?: { __typename?: 'VirtualTour', data: { __typename?: 'VirtualTour', attributes: { __typename?: 'VirtualTour', title: string, url: string } } } | null };

export const CategoryAttributesFragmentDoc = gql`
    fragment CategoryAttributes on Category {
  name
  slug
}
    `;
export const CategoryEntityAttributesFragmentDoc = gql`
    fragment CategoryEntityAttributes on Category {
  id
  attributes {
    ...CategoryAttributes
  }
}
    ${CategoryAttributesFragmentDoc}`;
export const ImageAttributesFragmentDoc = gql`
    fragment ImageAttributes on UploadFile {
  name
  caption
  formats
  createdAt
  updatedAt
  url
}
    `;
export const ImageEntityAttributesFragmentDoc = gql`
    fragment ImageEntityAttributes on UploadFile {
  id
  attributes {
    ...ImageAttributes
  }
}
    ${ImageAttributesFragmentDoc}`;
export const ExhibitAttributesFragmentDoc = gql`
    fragment ExhibitAttributes on Exhibit {
  slug
  title
  text
  moretext
  minimum_amount
  bidding_step
  createdAt
  updatedAt
  auctionEnabled
  sold
  category {
    data {
      ...CategoryEntityAttributes
    }
  }
  image {
    data {
      ...ImageEntityAttributes
    }
  }
}
    ${CategoryEntityAttributesFragmentDoc}
${ImageEntityAttributesFragmentDoc}`;
export const ExhibitEntityAttributesFragmentDoc = gql`
    fragment ExhibitEntityAttributes on Exhibit {
  id: documentId
  attributes {
    ...ExhibitAttributes
  }
}
    ${ExhibitAttributesFragmentDoc}`;
export const BidAttributesFragmentDoc = gql`
    fragment BidAttributes on Bid {
  amount
  createdAt
  updatedAt
  users_permissions_user {
    data {
      id
      attributes {
        username
      }
    }
  }
}
    `;
export const BidEntityAttributesFragmentDoc = gql`
    fragment BidEntityAttributes on Bid {
  id
  attributes {
    ...BidAttributes
  }
}
    ${BidAttributesFragmentDoc}`;
export const UserExhibitEntityAttributesFragmentDoc = gql`
    fragment UserExhibitEntityAttributes on Exhibit {
  id: documentId
  attributes {
    ...ExhibitAttributes
    bids: bids_connection(sort: ["amount:desc"], pagination: {limit: 1}) {
      data {
        ...BidEntityAttributes
      }
    }
  }
}
    ${ExhibitAttributesFragmentDoc}
${BidEntityAttributesFragmentDoc}`;
export const PaginationDetailsFragmentDoc = gql`
    fragment PaginationDetails on ResponseCollectionMeta {
  pagination {
    page
    total
    pageSize
    pageCount
  }
}
    `;
export const UserAttributesFragmentDoc = gql`
    fragment UserAttributes on UsersPermissionsMe {
  id
  lastName
  firstName
  username
  email
  mobile
  address
  zip
  city
}
    `;
export const TwilioVerifySettingsDocument = gql`
    query TwilioVerifySettings {
  twilioVerifySettings {
    enabled
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class TwilioVerifySettingsGQL extends Apollo.Query<TwilioVerifySettingsQuery, TwilioVerifySettingsQueryVariables> {
    override document = TwilioVerifySettingsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBidTokenDocument = gql`
    mutation CreateBidToken {
  createTwilioVerifyVerification {
    status
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBidTokenGQL extends Apollo.Mutation<CreateBidTokenMutation, CreateBidTokenMutationVariables> {
    override document = CreateBidTokenDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExhibitBidsDocument = gql`
    query ExhibitBids($filterInput: BidFiltersInput!, $pageSize: Int!) {
  bids: bids_connection(
    filters: $filterInput
    sort: ["updatedAt:desc"]
    pagination: {page: 0, pageSize: $pageSize}
  ) {
    data {
      ...BidEntityAttributes
    }
    meta {
      ...PaginationDetails
    }
  }
}
    ${BidEntityAttributesFragmentDoc}
${PaginationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExhibitBidsGQL extends Apollo.Query<ExhibitBidsQuery, ExhibitBidsQueryVariables> {
    override document = ExhibitBidsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CreateBidTransactionalDocument = gql`
    mutation CreateBidTransactional($input: BidInput!) {
  createBidTransactional(data: $input) {
    data {
      ...BidEntityAttributes
    }
  }
}
    ${BidEntityAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CreateBidTransactionalGQL extends Apollo.Mutation<CreateBidTransactionalMutation, CreateBidTransactionalMutationVariables> {
    override document = CreateBidTransactionalDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CategoriesDocument = gql`
    query Categories {
  categories: categories_connection(sort: "order:asc") {
    data {
      id
      attributes {
        ...CategoryAttributes
      }
    }
  }
}
    ${CategoryAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CategoriesGQL extends Apollo.Query<CategoriesQuery, CategoriesQueryVariables> {
    override document = CategoriesDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ContactDocument = gql`
    query Contact {
  contact {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ContactGQL extends Apollo.Query<ContactQuery, ContactQueryVariables> {
    override document = ContactDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExhibitionDocument = gql`
    query Exhibition {
  exhibition {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ExhibitionGQL extends Apollo.Query<ExhibitionQuery, ExhibitionQueryVariables> {
    override document = ExhibitionDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExhibitsDocument = gql`
    query Exhibits {
  exhibits: exhibits_connection {
    data {
      ...ExhibitEntityAttributes
    }
    meta {
      ...PaginationDetails
    }
  }
}
    ${ExhibitEntityAttributesFragmentDoc}
${PaginationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExhibitsGQL extends Apollo.Query<ExhibitsQuery, ExhibitsQueryVariables> {
    override document = ExhibitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CategoryExhibitsDocument = gql`
    query CategoryExhibits($categorySlug: String!, $pagination: PaginationArg = {page: 1, pageSize: 45}) {
  exhibits: exhibits_connection(
    filters: {sold: {eq: false}, category: {slug: {eq: $categorySlug}}}
    sort: ["order:asc, slug:asc"]
    pagination: $pagination
  ) {
    data {
      ...ExhibitEntityAttributes
    }
    meta {
      ...PaginationDetails
    }
  }
}
    ${ExhibitEntityAttributesFragmentDoc}
${PaginationDetailsFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class CategoryExhibitsGQL extends Apollo.Query<CategoryExhibitsQuery, CategoryExhibitsQueryVariables> {
    override document = CategoryExhibitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UserExhibitsDocument = gql`
    query UserExhibits {
  userExhibits {
    data {
      ...UserExhibitEntityAttributes
    }
  }
}
    ${UserExhibitEntityAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UserExhibitsGQL extends Apollo.Query<UserExhibitsQuery, UserExhibitsQueryVariables> {
    override document = UserExhibitsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ExhibitDocument = gql`
    query Exhibit($slug: String!) {
  exhibit(slug: $slug) {
    data {
      ...ExhibitEntityAttributes
    }
  }
}
    ${ExhibitEntityAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ExhibitGQL extends Apollo.Query<ExhibitQuery, ExhibitQueryVariables> {
    override document = ExhibitDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const GtcDocument = gql`
    query Gtc {
  gtc {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class GtcGQL extends Apollo.Query<GtcQuery, GtcQueryVariables> {
    override document = GtcDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ImpressumDocument = gql`
    query Impressum {
  impressum {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ImpressumGQL extends Apollo.Query<ImpressumQuery, ImpressumQueryVariables> {
    override document = ImpressumDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LaudatioDocument = gql`
    query Laudatio {
  laudatio {
    data {
      attributes {
        text
        title
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class LaudatioGQL extends Apollo.Query<LaudatioQuery, LaudatioQueryVariables> {
    override document = LaudatioDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const PolicyDocument = gql`
    query Policy {
  policy {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class PolicyGQL extends Apollo.Query<PolicyQuery, PolicyQueryVariables> {
    override document = PolicyDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegulationDocument = gql`
    query Regulation {
  regulation {
    data {
      attributes {
        text
        titel
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RegulationGQL extends Apollo.Query<RegulationQuery, RegulationQueryVariables> {
    override document = RegulationDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const MeDocument = gql`
    query Me {
  me {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class MeGQL extends Apollo.Query<MeQuery, MeQueryVariables> {
    override document = MeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const UpdateMeDocument = gql`
    mutation UpdateMe($data: UpdateMeInput!) {
  updateMe(data: $data) {
    ...UserAttributes
  }
}
    ${UserAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class UpdateMeGQL extends Apollo.Mutation<UpdateMeMutation, UpdateMeMutationVariables> {
    override document = UpdateMeDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const LoginDocument = gql`
    mutation Login($input: UsersPermissionsLoginInput!) {
  login(input: $input) {
    jwt
    user {
      ...UserAttributes
    }
  }
}
    ${UserAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class LoginGQL extends Apollo.Mutation<LoginMutation, LoginMutationVariables> {
    override document = LoginDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RegisterDocument = gql`
    mutation Register($input: UsersPermissionsRegisterInput!) {
  register(input: $input) {
    jwt
    user {
      ...UserAttributes
    }
  }
}
    ${UserAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class RegisterGQL extends Apollo.Mutation<RegisterMutation, RegisterMutationVariables> {
    override document = RegisterDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ForgotPasswordDocument = gql`
    mutation ForgotPassword($email: String!) {
  forgotPassword(email: $email) {
    ok
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class ForgotPasswordGQL extends Apollo.Mutation<ForgotPasswordMutation, ForgotPasswordMutationVariables> {
    override document = ForgotPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const ResetPasswordDocument = gql`
    mutation ResetPassword($password: String!, $code: String!) {
  resetPassword(password: $password, passwordConfirmation: $password, code: $code) {
    jwt
    user {
      ...UserAttributes
    }
  }
}
    ${UserAttributesFragmentDoc}`;

  @Injectable({
    providedIn: 'root'
  })
  export class ResetPasswordGQL extends Apollo.Mutation<ResetPasswordMutation, ResetPasswordMutationVariables> {
    override document = ResetPasswordDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const VirtualTourDocument = gql`
    query VirtualTour {
  virtualTour {
    data {
      attributes {
        title
        url
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class VirtualTourGQL extends Apollo.Query<VirtualTourQuery, VirtualTourQueryVariables> {
    override document = VirtualTourDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }